import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';
import type { ModalClassNameModifier } from './ModalClassNameModifiers';

type FooterProps = {
  children: React.ReactNode;
  classNameModifier?: ModalClassNameModifier;
};

const Footer: FC<FooterProps> = ({ children, classNameModifier = '' }) => (
  <div className={getClassNames(styles, 'footer', classNameModifier)}>
    {children}
  </div>
);

export default Footer;
